var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect } from 'react';
import styled from '../../styled';
import { media } from '../../themes/breakpoint';
import { fadeOut, fadeIn, slideIn, slideOut } from '../../keyframes';
import { Cross } from '../icons/outline';
import { Alert as AlertIcon, Risk, CircleTick } from '../icons/solid';
const Container = styled.div `
  display: flex;
  z-index: ${({ theme }) => theme.zIndex.Toast};
  width: 25rem;
  border-radius: 6px;
  box-shadow: 0 0 1rem 0 ${({ theme }) => theme.colors.SHADOW_DEFAULT},
    0 0.0625rem 0.1875rem 0 ${({ theme }) => theme.colors.SHADOW_DARK};
  padding: 1rem;
  margin-bottom: 0.25rem;
  background-color: ${({ theme, toastKey }) => theme.colors[theme.toast.types[toastKey].backgroundColor]};
  color: ${({ theme }) => theme.colors.SNOW_100};
  box-sizing: border-box;
  animation: ${({ isShow }) => (isShow ? fadeIn : fadeOut)} 0.5s linear both,
    ${({ isShow }) => (isShow ? slideIn : slideOut)} 0.5s linear;

  ${media.mobile `
    width: 100%;
    border-radius: 0;
  `};
`;
const IconContainer = styled.div `
  flex-direction: column;
  padding-right: 1rem;
  line-height: 0;
`;
const Body = styled.div `
  flex-direction: column;
  flex: 1;
`;
const Title = styled.div `
  font-weight: 600;
  line-height: 1.5;
`;
const Description = styled.div `
  line-height: ${({ theme, lang }) => theme.fonts.Body.lineHeight[lang]}
  font-size: 0.875rem;
`;
const CrossContainer = styled.div `
  flex-direction: column;
  padding: 0.25rem 0 0 0.25rem;
  line-height: 0;

  > div {
    cursor: pointer;

    &:hover {
      > svg {
        fill: ${({ theme, toastKey }) => theme.colors[theme.toast.types[toastKey].hoverColor]};
      }
    }
  }
`;
const IconMap = {
    success: React.createElement(CircleTick, { size: "LARGE", color: "SNOW_100" }),
    alert: React.createElement(Risk, { size: "LARGE", color: "SNOW_100" }),
    warning: React.createElement(AlertIcon, { size: "LARGE", color: "SNOW_100" }),
    information: React.createElement(AlertIcon, { size: "LARGE", color: "SNOW_100", position: "BOTTOM" }),
};
const toastGenerator = (toastKey) => (_a) => {
    var { title, description, lang = 'en', isShow = false, onClick, onAnimationEnd, e2eId } = _a, restProps = __rest(_a, ["title", "description", "lang", "isShow", "onClick", "onAnimationEnd", "e2eId"]);
    const [shouldRender, setRender] = useState(isShow);
    const icon = IconMap[toastKey];
    useEffect(() => {
        if (isShow) {
            setRender(true);
        }
    }, [isShow]);
    const handleOnAnimationEnd = (event) => {
        if (!isShow) {
            setRender(false);
        }
        if (onAnimationEnd) {
            onAnimationEnd(event);
        }
    };
    return shouldRender ? (React.createElement(Container, Object.assign({}, restProps, { "data-e2e-id": e2eId, toastKey: toastKey, isShow: isShow, onAnimationEnd: handleOnAnimationEnd }),
        React.createElement(IconContainer, null, icon),
        React.createElement(Body, null,
            React.createElement(Title, null, title),
            description && React.createElement(Description, { lang: lang }, description)),
        React.createElement(CrossContainer, { toastKey: toastKey },
            React.createElement("div", { onClick: onClick, role: "presentation" },
                React.createElement(Cross, { size: "SMALL", color: "SNOW_100" }))))) : null;
};
export const Success = toastGenerator('success');
export const Alert = toastGenerator('alert');
export const Warning = toastGenerator('warning');
export const Information = toastGenerator('information');
//# sourceMappingURL=Toast.js.map